import { isMcKissockOfferType } from '@aloft/toolkit-shared';

import { useEffect, useRef } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { OnboardingModule } from '../../modules/onboarding/OnboardingModule.tsx';
import { MCKISSOCK_PARAM_KEY, REFERRED_BY_PARAM_KEY } from '../../modules/onboarding/consts.ts';
import { OnboardingModuleProps } from '../../modules/onboarding/types.ts';
import { useCreateAllTrainingOrders } from '../../modules/orderManagement/hooks/useCreateAllTrainingOrders.ts';
import { SubscriptionModule } from '../../modules/subscription/SubscriptionModule.tsx';
import { selectIsOnboardingComplete } from '../../redux/features/selectors/accountSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { useToolkitControllerGlobal } from '../hooks/useToolkitControllerGlobal.ts';

const InjectedSubscriptionModule: OnboardingModuleProps['SubscriptionModule'] = (props) => (
  <SubscriptionModule
    {...props}
    // NOTE: This is currently not used as we don't accept payment methods that require
    // redirection: https://docs.stripe.com/payments/payment-methods/overview#bank-redirects
    redirectURL="https://toolkit.aloftappraisal.com/orders"
  />
);

export const OnboardingRouteElement = () => {
  const { subscription } = useToolkitControllerGlobal();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const isOnboardingCompleteOnMount = useRef(isOnboardingComplete);

  const [searchParams] = useSearchParams();

  const createAllTrainingOrders = useCreateAllTrainingOrders(false);

  useEffect(() => {
    createAllTrainingOrders();
  }, []);

  if (subscription.hasActiveSubscription) {
    return <Navigate to="/orders" />;
  }

  if (isOnboardingCompleteOnMount.current) {
    return <Navigate to="/subscribe" />;
  }

  const offer = searchParams.get(MCKISSOCK_PARAM_KEY);
  const mcKissockOffer = isMcKissockOfferType(offer) ? offer : undefined;

  return (
    <OnboardingModule
      referralCode={searchParams.get(REFERRED_BY_PARAM_KEY)}
      mcKissockOffer={mcKissockOffer}
      SubscriptionModule={InjectedSubscriptionModule}
    />
  );
};
